import { DashboardVehicle } from '../types/DashboardVehicle';
import { isVehicleApplicationInSubmission } from './isVehicleApplicationInSubmission';

export const shouldConfirmVehicle = (
  vehicle: DashboardVehicle | null | undefined,
): boolean =>
  Boolean(vehicle) &&
  !vehicle.isConfirmed &&
  !isVehicleApplicationInSubmission(vehicle);
